<template>
  <div>
    <component
      :is="listTag"
      :class="listClasses"
      class="text-[1.6rem] ml-14 my-16 text-text-primary"
    >
      <li
        v-for="(item, idx) in configData.Items"
        :key="idx"
        class="heading-xxs"
      >
        {{ item.Text }}
      </li>
    </component>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    ListStyle?: string;
    Items?: {
      Text: string;
    }[];
  };
}

const props = defineProps<Props>();
const listTag = computed(() => {
  return props.configData.ListStyle?.toLowerCase() === 'numbered' ? 'ol' : 'ul';
});

const listClasses = computed(() => {
  return props.configData.ListStyle?.toLowerCase() === 'numbered'
    ? 'list-decimal'
    : 'list-disc';
});
</script>

<style scoped></style>
